module.exports = __webpack_public_path__ + "static/hero-598cff563a6cd4a4b307055f1cf10e84.png";